"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptStatuses = exports.LawfulBasis = void 0;

var keyMirror = function keyMirror(obj) {
  var ret = {};
  var key;

  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }

  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }

    ret[key] = key;
  }

  return ret;
};

var LawfulBasis = keyMirror({
  LEGITIMATE_INTEREST_PQL: null,
  LEGITIMATE_INTEREST_CLIENT: null,
  PERFORMANCE_OF_CONTRACT: null,
  CONSENT_WITH_NOTICE: null,
  NON_GDPR: null
});
exports.LawfulBasis = LawfulBasis;
var OptStatuses = keyMirror({
  OPT_IN: null,
  OPT_OUT: null,
  NOT_OPTED: null
});
exports.OptStatuses = OptStatuses;